import ConnectedDevicesWidget from './component'

export default ConnectedDevicesWidget
